import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Browse from "@/pages/Browse";
import PropertyDetail from "@/pages/PropertyDetail";
import HostDashboard from "@/pages/HostDashboard";
import HostSchedule from "@/pages/HostSchedule";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminInsights from "@/pages/AdminInsights";
import CertificationPublic from "@/pages/CertificationPublic";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Vision from "@/pages/Vision";
import AdminWaitlist from "@/pages/AdminWaitlist";
import Pricing from "@/pages/Pricing";
import Favorites from "@/pages/Favorites";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import Refund from "@/pages/Refund";
import CityPage from "@/pages/CityPage";
import Wellness from "@/pages/Wellness";
import Footer from "@/components/Footer";
import ExitIntentPopup from "@/components/ExitIntentPopup";
import ScrollToTop from "@/components/ScrollToTop";
import "@/App.css";

function Protected({ children, role }) {
  const { user } = useAuth();
  if (user === null) return <div className="p-10 text-slate-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) return <Navigate to="/" replace />;
  return children;
}

function AppShell() {
  return (
    <div className="App">
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/browse" element={<Browse />} />
        <Route path="/stays/:slug" element={<CityPage />} />
        <Route path="/wellness" element={<Wellness />} />
        <Route path="/property/:id" element={<PropertyDetail />} />
        <Route path="/certification/:code" element={<CertificationPublic />} />
        <Route path="/vision" element={<Vision />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/refund" element={<Refund />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="/host" element={<Protected role="host"><HostDashboard /></Protected>} />
        <Route path="/host/schedule" element={<Protected role="host"><HostSchedule /></Protected>} />
        <Route path="/favorites" element={<Protected role="guest"><Favorites /></Protected>} />
        <Route path="/admin" element={<Protected role="admin"><AdminDashboard /></Protected>} />
        <Route path="/admin/insights" element={<Protected role="admin"><AdminInsights /></Protected>} />
        <Route path="/admin/waitlist" element={<Protected role="admin"><AdminWaitlist /></Protected>} />
      </Routes>
      <Footer />
      <Toaster position="top-right" />
      <ExitIntentPopup />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppShell />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
